/**
* @Description 文件功能说明：webSoket player 组件
* @Author CC
* @Time 2021/8/14
**/
<template>
	<section>
		<!-- webSoket -->
		<SubWebsoket ref="wsPlayer" v-if="wsFilter.creatWsFlag"
			:wsUrl="wsFilter.wsUrl"
			:wsKey="wsFilter.wsKey"
			:autoRecreatFlag="wsFilter.autoRecreatFlag"
			:wsOnopen="wsFilter.wsOnopen"
			:wsOnmessage="wsFilter.wsOnmessage"
			:wsOnerror="wsFilter.wsOnerror"
			:wsOnclose="wsFilter.wsOnclose"
			:winMessageFn="wsFilter.winMessageFn"
		/>
	</section>
</template>

<script>
	// ws Api
	import ApiNfcWs from '@/request/api-nfc_ws'
	// 组件 webSoket
	import SubWebsoket from '@/components/SubWebsoket'
	
	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2021/8/14
		 */
		name: 'SubJkkcPlayer',
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2021/8/14
		 */
		components: {
			// 组件 webSoket
			SubWebsoket,
		},
		/**
		 * @Des 接收数据
		 * @Auth
		 * @Date 2021/8/14
		 */
		props: {
			/**
			 * @Des 创建 ws flag
			 * @Auth
			 * @Date 2021/8/14
			 */
			creatWsFlag: {
                type: Boolean,
                default: function (){
                    return true;
                }
            },
            /**
			 * @Des webSoket key
			 * @Auth
			 * @Date 2021/8/14
			 */
			wsKey: {
                type: String,
                default: function (){
                    return '_wsPlayer';
                }
            },
            /**
			 * @Des 自动重新连接
			 * @Auth
			 * @Date 2021/8/14
			 */
			autoRecreatFlag: {
                type: Boolean,
                default: function (){
                    return true;
                }
            },
            /**
			 * @Des 连接已打开
			 * @Auth
			 * @Date 2021/8/14
			 */
			wsOnopen: {
                type: Function,
                default: function (){
                    return null;
                }
            },
            /**
			 * @Des 数据推送
			 * @Auth
			 * @Date 2021/8/14
			 */
			wsOnmessage: {
                type: Function,
                default: function (){
                    return null;
                }
            },
            /**
			 * @Des 无 this.wsOnmessage 时，onmessage 监听回调 {方法名称}
			 * @Auth
			 * @Date 2021/8/14
			 */
			winMessageFn: {
                type: Function,
                default: function (){
                    return null;
                }
            },
            /**
			 * @Des 连接发生错误
			 * @Auth
			 * @Date 2021/8/14
			 */
			wsOnerror: {
                type: Function,
                default: function (){
                    return null;
                }
            },
            /**
			 * @Des 连接关闭
			 * @Auth
			 * @Date 2021/8/14
			 */
			wsOnclose: {
                type: Function,
                default: function (){
                    return null;
                }
            },
		},
		
		/**
		 * @Des 加载执行 pre
		 * @Auth
		 * @Date 2021/8/14
		 */
		created() {
			
		},
		/**
		 * @Des 加载完成执行
		 * @Auth
		 * @Date 2021/8/14
		 */
		mounted() {
			
		},
		/**
		 * @Des 销毁之前执行
		 * @Auth
		 * @Date 2021/8/14
		 */
		beforeDestroy() {
			
		},
		
		/**
		 * @Des 数据模型
		 * @Auth
		 * @Date 2021/8/14
		 */
		data() {
			return {
				
				/**
				 * @Des webSoket参数
				 * @Auth
				 * @Date 2021/8/14
				 */
				wsFilter: {
					// 创建 ws flag
					creatWsFlag: this.creatWsFlag,
					// webSoket路径
					wsUrl: ApiNfcWs.wsUrlPlayer,
					// webSoket key
					wsKey: this.wsKey,
					// 自动重新连接
					autoRecreatFlag: this.autoRecreatFlag,
					// 连接已打开
					wsOnopen: this.wsOnopen,
					// 连接 发生错误
					wsOnerror: this.wsOnerror,
					// 连接 关闭
					wsOnclose: this.wsOnclose,
					// 数据推送
					wsOnmessage: this.wsOnmessage,
					// 无 this.wsOnmessage 时，onmessage 监听回调 {方法名称}
					winMessageFn: this.winMessageFn,
					// this.onMessage 与 this.wsOnmessage 存一即可
				},
				
			}
		},
		/**
		 * @Des 方法
		 * @Auth
		 * @Date 2021/8/14
		 */
		methods: {
			// 发送数据
            send(message) {
            	this.$refs.wsPlayer &&  this.$refs.wsPlayer.wsSend(message);
            },
            // 发送心跳
            sendPing() {
            	this.$refs.wsPlayer &&  this.$refs.wsPlayer.sendPing();
            },
		},
		
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/SubJkkcPlayer.vue